import React, { useState } from 'react';
import { Box, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { LegalTemplateComponent } from '../../Pages/HomePages/legalTemplate';
import { StaffDailyCourtCasesComponent } from '../../Pages/HomePages/staffDailyCourtCases';
import { StaffDailyHighCourtCasesComponent } from '../../Pages/HomePages/staffDailyHighCourtCases';
import { StaffDailySupremeCourtCasesComponent } from '../../Pages/HomePages/StaffDailySupremeCourtCases';
import { StaffLegalTeamComponent } from '../../Pages/adminMgmt/staffMgmt/staffLegalTeam';
import { StaffSOPComponent } from '../../Pages/adminMgmt/staffMgmt/staffSop';
import { StaffKeyJudgementComponent } from '../../Pages/adminMgmt/staffMgmt/staffSpecialCourtOrders';
import { StaffHighCourtComponent } from '../../Pages/adminMgmt/staffMgmt/staffHighCourtOrders';
import { StaffOtherStateCourtComponent } from '../../Pages/adminMgmt/staffMgmt/staffOtherStateOrders';
import { StaffFaqComponent } from '../../Pages/adminMgmt/staffMgmt/staffFaq';
import { StaffManualVideos } from '../../Pages/adminMgmt/staffMgmt/staffManuals';
import { StaffCircularNotificationComponent } from '../../Pages/adminMgmt/staffMgmt/staffCirculars';
import { StaffOfficeOrders } from '../../Pages/adminMgmt/staffMgmt/staffOfficeOrders';
import { StaffSupremeCourtComponent } from '../../Pages/adminMgmt/staffMgmt/staffSupremeCourtOrders';
import { StaffAssetFirComponent } from '../../Pages/assetMgmt/assetFir';
import { StaffAsset32Component } from '../../Pages/assetMgmt/asset32';
import { StaffAssetPropertyDetailsComponent } from '../../Pages/assetMgmt/assetProperty';
import { StaffAsset52Component } from '../../Pages/assetMgmt/asset52';
import { StaffAssetValuationComponent } from '../../Pages/assetMgmt/assetValuation';
import { StaffAssetAuctionComponent } from '../../Pages/assetMgmt/assetAuction';
import { StaffAssetSec8Component } from '../../Pages/assetMgmt/assetSec8';
import { MasterAssetComponent } from '../../Pages/assetMgmt/masterAsset';
import { StaffAssetSec13Component } from '../../Pages/assetMgmt/assetSec13';
// import { StaffAssetCAComponent } from '../../Pages/assetMgmt/assetCaBase';
// import { AdminAdvertisementComponent } from '../../Pages/adminMgmt/adminAdvatizement';
// import { AdminAuctionComponent } from '../../Pages/adminMgmt/adminAuction';
// import { AdminCalendarEvents } from '../../Pages/adminMgmt/adminCalenderEvents';
// import { AdminCircularNotificationComponent } from '../../Pages/adminMgmt/adminCircularNotification';
// import { AdminDailyCourtCasesComponent } from '../../Pages/adminMgmt/adminDailyCourtReport';
// import { AdminFEComponent } from '../../Pages/adminMgmt/adminFe';
// import { AdminAssignedFinancialEstablishmentComponent } from '../../Pages/adminMgmt/adminFinancialEstablishment';
// import { AdminGovtOrdersComponent } from '../../Pages/adminMgmt/adminGovtOrder';
// import { AdminHeadOfficeComponent } from '../../Pages/adminMgmt/adminHeadOffice';
// import { AdminDepositorInfoComponent } from '../../Pages/adminMgmt/adminInfoToDepositor';
// import { AdminKeyJudgementComponent } from '../../Pages/adminMgmt/adminKeyJudgement';
// import { AdminKpidActComponent } from '../../Pages/adminMgmt/adminKpidRules';
// import { AdminManualVideosComponent } from '../../Pages/adminMgmt/adminManualVideos';
// import { AdminOfficeOrdersComponent } from '../../Pages/adminMgmt/adminOfficeOrders';
// import { AdminTenderComponent } from '../../Pages/adminMgmt/adminTenders';
// import { AdminNewsComponent } from '../../Pages/adminMgmt/adminNews';
// import { AdminNotificationComponent } from '../../Pages/adminMgmt/adminNotification';
// import { AdminLegalTeamComponent } from '../../Pages/adminMgmt/adminLegalTeam'; 
// import {AdminBudsActComponent} from '../../Pages/adminMgmt/adminBudsAct'
// import { AdminDailySupremeCourtCasesComponent } from '../../Pages/adminMgmt/adminDailySupremeCourtCases';
// import { AdminDailyHighCourtCasesComponent } from '../../Pages/adminMgmt/adminDailyHighCortCases';
// import { AdminOtherStatePIDFEComponent } from '../../Pages/adminMgmt/adminOtherStatePIDFE';
// import { AdminOtherReleventActComponent } from '../../Pages/adminMgmt/adminOtherReleventActs';
// import { AdminComparissnOfActComponent } from '../../Pages/adminMgmt/AdminComparisnOfActs';
// import {AdminLegalTemplateComponent}from '../../Pages/adminMgmt/adminLegalTemplate';
// import {AdminFaqComponent} from '../../Pages/adminMgmt/adminFaq';
// import {AdminLegalBlogsComponent} from '../../Pages/adminMgmt/adminLegalBlog';
// import {AdminScamNewsComponent} from '../../Pages/adminMgmt/adminScamNews'
// import { AdminHighCourtComponent } from '../../Pages/adminMgmt/adminHighCourtOrders';
// import { AdminSupremeCourtComponent } from '../../Pages/adminMgmt/supremeCourtOrders';
// import { AdminOtherStateCourtComponent } from '../../Pages/adminMgmt/adminOtherStateCourtOrders';
// import { AdminSOPComponent } from '../../Pages/adminMgmt/adminSop';
// import { AdminLegalOpinionComponent } from '../../Pages/adminMgmt/adminLegalOpinion';
// import { AdminLegalResearchComponent } from '../../Pages/adminMgmt/AdminLegalResearch';
// import OrgChartAdmin from '../../Pages/orgChart/adminChart';


const StaffDropdownComponent = () => {
  const [selectedOption, setSelectedOption] = useState('');

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const renderComponent = () => {
    switch (selectedOption) {
    //   case 'A':
    //     return <Box><AdminAdvertisementComponent /></Box>;
    //   case 'B':
    //     return <Box><AdminAuctionComponent/></Box>;
    //   case 'C':
    //     return <Box><AdminCalendarEvents/></Box>;

      case 'D':
        return <Box><StaffCircularNotificationComponent/></Box>;
      case 'E':
        return <Box><StaffDailyCourtCasesComponent/></Box>;
    //   case 'F':
    //     return <Box><AdminFEComponent/></Box>;
    //   case 'G':
    //     return <Box><AdminAssignedFinancialEstablishmentComponent/></Box>;
    //   case 'H':
    //     return <Box><AdminGovtOrdersComponent/></Box>;
    //   case 'I':
    //     return <Box><AdminHeadOfficeComponent/></Box>;
    //   case 'J':
    //     return <Box><AdminDepositorInfoComponent/></Box>;
      case 'K':
        return <Box><StaffDailyHighCourtCasesComponent/></Box>;
      case 'L':
        return <Box><StaffDailySupremeCourtCasesComponent/></Box>;
      case 'M':
        return <Box><StaffLegalTeamComponent/></Box>;
      case 'N':
        return <Box><StaffSOPComponent/></Box>;
    //   case 'O':
    //     return <Box><AdminTenderComponent/></Box>;
    //   case 'P':
    //     return <Box><AdminNewsComponent/></Box>;
    //   case 'Q':
    //     return <Box><AdminNotificationComponent/></Box>;
      case 'R':
        return <Box><StaffKeyJudgementComponent/></Box>;
      case 'S':
        return <Box><StaffHighCourtComponent/></Box>
      case 'T':
        return <Box><StaffOtherStateCourtComponent/></Box>
      case 'U':
        return <Box><StaffFaqComponent/></Box>
      case 'V':
        return <Box><StaffManualVideos/></Box>
      case 'W':
        return <Box><StaffOfficeOrders/></Box>
      case 'X':
        return <Box><StaffSupremeCourtComponent/></Box>

      case 'Y':
        return <Box><StaffAssetFirComponent/></Box>
      case 'Z':
        return <Box><StaffAsset32Component/></Box>
      case 'AA':
        return <Box><StaffAssetPropertyDetailsComponent/></Box>
      case 'BB':
        return <Box><StaffAsset52Component/></Box>
      case 'CC':
        return <Box><StaffAssetValuationComponent/></Box>
      case 'DD':
        return <Box><StaffAssetAuctionComponent/></Box>
      case 'EE':
        return <Box><StaffAssetSec8Component/></Box>

      case 'FF':
        return <Box><MasterAssetComponent/></Box>
      case 'GG':
        return <Box><StaffAssetSec13Component/></Box>
    //   case 'HH':
    //     return <Box><AdminLegalResearchComponent/></Box>
      
    //   case 'II':
    //     return <Box><OrgChartAdmin/></Box>

      default:
        return <Typography variant="h6">Please select an option</Typography>;
    }
  };

  return (
    <Box sx={{ width: '100%', padding: 2 }}>
      <Box sx={{ width: 300 }}>
        <FormControl fullWidth>
          <InputLabel id="dropdown-label">Select Option</InputLabel>
          <Select labelId="dropdown-label" value={selectedOption} label="Select Option" onChange={handleChange}>
            {/* <MenuItem value="A">Advatizement</MenuItem>
            <MenuItem value="B">Auctions</MenuItem>
            <MenuItem value="C">Calender Event</MenuItem> */}
            <MenuItem value="D">Circulars & Notifications</MenuItem>
            <MenuItem value="E">Special Court cases</MenuItem>
            {/* <MenuItem value="F">FE</MenuItem>
            <MenuItem value="G">Assigned Financial Establishment</MenuItem>
            <MenuItem value="H">Govt Orders</MenuItem>
            <MenuItem value="I">Head Offices</MenuItem>
            <MenuItem value="J">Info to Depositor</MenuItem> */}
            <MenuItem value="K">High Court Cases</MenuItem>
            <MenuItem value="L">Supreme Court Cases</MenuItem>
            <MenuItem value="M">Employee Directory</MenuItem>
            <MenuItem value="N">SOP</MenuItem>
            {/* <MenuItem value="O">Tenders</MenuItem>
            <MenuItem value="P">News</MenuItem>
            <MenuItem value="Q">Home Notifications</MenuItem> */}
            <MenuItem value="R">Special Court Orders</MenuItem>
            <MenuItem value="S">High Court Orders</MenuItem>
            <MenuItem value="T">Other State Orders</MenuItem>
            <MenuItem value="U">FAQ</MenuItem>
            <MenuItem value="V">Manuals</MenuItem>
            <MenuItem value="W">Office Orders</MenuItem>
            <MenuItem value="X">Supreme Court Orders</MenuItem>
            <MenuItem value="Y">FIR</MenuItem> 
            <MenuItem value="Z">3(2)</MenuItem> 
            <MenuItem value="AA">Property Details</MenuItem> 
            <MenuItem value="BB">5(2)</MenuItem> 
            <MenuItem value="CC">Valuation</MenuItem> 
            <MenuItem value="DD">Auction</MenuItem> 
             <MenuItem value="EE">Section 8 Details</MenuItem> 
            <MenuItem value="FF">Master Asset</MenuItem> 
             <MenuItem value="GG">Section 13</MenuItem> 
             {/*
            <MenuItem value="HH">Legal Research</MenuItem>
            <MenuItem value="II">Org Chart Mgmt</MenuItem> */}

          </Select>
        </FormControl>
      </Box>
      <Box sx={{ marginTop: 3, width: '100%' }}>
        {renderComponent()}
      </Box>
    </Box>
  );
};

export default StaffDropdownComponent;
